/* eslint-disable */
import messages from "./messages";

export const loginPatt = /^(?:[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)(?!.)/;

export const namePatt = /^(?:[A-Za-z0-9!#$%&"();:,<>@'*+\/\[\]\\=?^_`{|}~-]*)(?!.)/;

export const selectOptions = {
  domain: [
    {
      id: "basf",
      label: "@basf.com",
    },
    {
      id: "sa",
      label: "@sm-analytics.com",
    },
  ],
};

export const addUserFormConfig = [
  {
    id: "name",
    name: messages.name,
    type: "text",
    selectOptions: [],
    selectId: "",
    maxLength: 50,
  },
  {
    id: "surname",
    name: messages.surname,
    type: "text",
    selectOptions: [],
    selectId: "",
    maxLength: 50,
  },
  {
    id: "login",
    name: messages.login,
    type: "text",
    selectOptions: [],
    selectId: "",
    maxLength: undefined,
  },
  {
    id: "department",
    name: messages.department,
    type: "select",
    selectOptions: [
      {
        id: 1,
        label: "department 1",
      },
      {
        id: 2,
        label: "department 2",
      },
      {
        id: 3,
        label: "department 3",
      },
    ],
    selectId: "",
    inputAdornment: "",
    maxLength: undefined,
  },
];

export const INITIAL_FORM_STATE = {
  department: 1,
  requiredFields: {
    name: "",
    surname: "",
    login: "",
  },
  errors: {
    name: false,
    surname: false,
    login: false,
    loginResponse: false,
    domain: false,
    department: false,
  },
  showErrorMessage: false,
  dirty: false,
};

export const ROWS_PER_PAGE = 14;

export const INITIAL_SORTING_ID = "registrationDate";

export const ASCENDING_ORDER = "asc";

export const DESCENDING_ORDER = "desc";

export const MAX_NAME_LENGTH = 50;

export const MAX_SURNAME_LENGTH = 100;

export const MAX_LOGIN_LENGTH = 64;
